import { motion, AnimatePresence } from "framer-motion";
import { useRef, useState, useEffect } from "react";

const VideoPreloader = ({ isVisible, onFinish }) => {
  const videoRef = useRef(null);
  const [isMuted, setIsMuted] = useState(true);

  const toggleSound = async () => {
    if (!videoRef.current) return;

    const nextMuted = !isMuted;
    setIsMuted(nextMuted);
    videoRef.current.muted = nextMuted;

    if (!nextMuted) {
      try {
        await videoRef.current.play();
      } catch (e) {}
    }
  };

  useEffect(() => {
    if (!isVisible) return;
    const timer = setTimeout(onFinish, 5000);
    return () => clearTimeout(timer);
  }, [isVisible, onFinish]);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          className="fixed inset-0 z-[9999] bg-black"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.4 }}
        >
          {/* Fullscreen Video */}
          <video
            ref={videoRef}
            src="/PreLoader.mp4"
            autoPlay
            muted={isMuted}
            playsInline
            className="
   absolute inset-0 w-full h-full
  object-contain
  bg-white
"
          />

          {/* 🔥 Highlighted Sound Button */}
          {/* Centered Sound Button Wrapper */}
          {/* <div className="absolute inset-0 flex items-end justify-center pb-10 sm:pb-8">
            <motion.button
              onClick={toggleSound}
              initial={{ scale: 1 }}
              animate={{ scale: [1, 1.08, 1] }}
              transition={{
                repeat: Infinity,
                duration: 1.6,
                ease: "easeInOut",
              }}
              className="
      h-14 w-56
      rounded-full
      flex items-center justify-center gap-3
      bg-black/50 backdrop-blur-md
      border border-amber-400/60
      text-amber-300
      text-sm font-medium tracking-wide
      shadow-lg shadow-amber-500/30
    "
            >
              <span className="text-lg">{isMuted ? "🔊" : "🔇"}</span>
              {isMuted ? "Tap to enable sound" : "Tap to mute"}
            </motion.button>
          </div> */}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default VideoPreloader;
